import { IStrapiBaseEntity } from './types/client';
import { StrapiBaseEntityServer } from './types/server';

export abstract class StrapiBaseEntityModel implements IStrapiBaseEntity {
  readonly id;
  readonly documentId;
  readonly createdAt;
  readonly updatedAt;
  readonly publishedAt;

  constructor(params: IStrapiBaseEntity) {
    this.id = params.id;
    this.documentId = params.documentId;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.publishedAt = params.publishedAt;
  }

  static getBaseEntityFromJson(raw: StrapiBaseEntityServer): IStrapiBaseEntity {
    return {
      id: raw.id,
      documentId: raw.documentId,
      createdAt: new Date(raw.createdAt),
      updatedAt: new Date(raw.updatedAt),
      publishedAt: new Date(raw.publishedAt),
    };
  }
}
